/*jshint esversion: 6 */
jQuery(function($) {

  /******************************************/
    /********** VAR-----------/
  /******************************************/

  var LARGEUR_MAX_MOBILE = 800;
  var header = $("#masthead");
  var topMenuHeight = 80;
  var l_window_w = parseInt($(window).width());


  $('.to_nicedropdown-js').niceSelect();


  /******************************************/
    /********** SCROLL - NAV -----------/
  /******************************************/
 $(window).scroll(function () {
      action_on_scroll();
  });

  function action_on_scroll(){

     if ($(window).scrollTop() > 0){
        header.addClass("Masthead--sticky");
        $("body").addClass('header--sticky');
      }else{
         header.removeClass("Masthead--sticky");
        $("body").removeClass('header--sticky');
      }

   }


  /* *****************  */
    /* SMOOTH SCROLL :  BACK TO TOP */
  /* *****************  */

    var linkboulangerie = $('.scrollToTop--js');
     linkboulangerie.click(function(e){

    var href = $(this).attr("href"),
        offsetTop = href === "#" ? 0 : $(href).offset().top - 0 - 0;
  
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 600);
     
      e.preventDefault();
  });




/* ********************************************** */
/* **** SUB MENU SUR LA GAUCHE ************* */
/* ********************************************** */

       // Cache selectors
  var lastId,
      topMenu = $("#masthead"),
      $SubMenuLink = $(".nav_boulangerie"),
      // All list menuItems
      menuItems = $SubMenuLink.find("a"),
      // Anchors corresponding to menu items
      scrollItems = menuItems.map(function(){
        var item = $($(this).attr("href"));
        if (item.length) {return item;}
      });
   
 
  // Bind click handler to menu items
  // so we can get a fancy scroll animation
  menuItems.click(function(e){
    var href = $(this).attr("href");
    var variable = 86;
        var offsetTop = href === "#" ? 0 : $(href).offset().top - topMenuHeight-variable;
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 500);
        
     
      e.preventDefault();
  });

    // Bind to scroll
  $(window).scroll(function(){
     // Get container scroll position
     var fromTop = $(this).scrollTop();
    
     // Get id of current scroll item
     var cur = scrollItems.map(function(){
        variable_top = 90;
       if ($(this).offset().top - topMenuHeight - variable_top < fromTop)
       {

         return this;
       }
     });
     // Get the id of the current element
     cur = cur[cur.length-1];
     var id = cur && cur.length ? cur[0].id : "intro-boulangerie";
      
     if (lastId !== id) {
         lastId = id;
         // Set/remove active class
         menuItems.removeClass("active");
         menuItems.filter("a[href='#"+id+"']").addClass("active");
     }else{
      // console.log('here' + id);
      // menuItems.filter("a[href='#section_1']").addClass("active");
     }                 
  });



    /*********************************/
    /** SLIDE - HOME PAGE **/
    /*********************************/

      $('.js-SlideHome').slick({
            //setting-name: setting-value
          dots: true,
          arrows:false,
          draggable:true,
          autoplay: true,
          autoplaySpeed: 4500,
          pauseOnHover:false,
          pauseOnFocus:false,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed:1500,
         // fade: true, // a tester //
         // cssEase: 'ease-out',
          rows: 0,
           responsive: [
          {
            breakpoint: 701,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:false,
              dots: true,
            }
          }
        ]
           
    });

   
    let delay_slide = 1100;
    let base_autoslide = 3500;
    $( ".js-SlideHome" ).each(function( index ) {
      $(this).slick('slickSetOption', 'autoplaySpeed', base_autoslide+delay_slide*index, true);
    });



// EFFECT TXT HOME

// Wrap every letter in a span
var textWrapper = document.querySelector('.ml12');
if (textWrapper) {
textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");

anime.timeline({loop: true})
  .add({
    targets: '.ml12 .letter',
    translateX: [40,0],
    translateZ: 0,
    opacity: [0,1],
    easing: "easeOutExpo",
    duration: 1200,
    delay: (el, i) => 500 + 30 * i
  }).add({
    targets: '.ml12 .letter',
    translateX: [0,-30],
    opacity: [1,0],
    easing: "easeInExpo",
    duration: 1100,
    delay: (el, i) => 300 + 30 * i
  });
}


  // FORM CONTACT LABEL ///

  $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

  $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });


   
  // ** //
  // AU RECHARGEMENT OU AU SCROLL DE LA PAGE = ON FAIT SCROLL SMOOTH VERS LA POSITION // 
  // ** // 
  function scroll_good_anchor(){
     if(window.location.hash) {
      var $hash_location = window.location.hash;
      var variable_here = 86;
      if($($hash_location).length){
         var offsetTop = $hash_location === "#" ? 0 : $($hash_location).offset().top-topMenuHeight-variable_here;
          $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 500);
      }
    } 
  }

  scroll_good_anchor();


  ////////* SLIDE HOME *///////
  // https://codepen.io/digistate/pen/MvapbE

  var slideWrapper = $(".homemain-slider"),
    iframes = slideWrapper.find('.embed-player');
    //lazyImages = slideWrapper.find('.slide-image'),
   // lazyCounter = 0;

// POST commands to YouTube API
function postMessageToPlayer(player, command){
  if (player == null || command == null) return;
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}

// When the slide is changing
function playPauseVideo(slick, control){
  var currentSlide, slideType, startTime, player, video;

  currentSlide = slick.find(".slick-current");
  slideType = currentSlide.attr("class").split(" ")[1];
  player = currentSlide.find("iframe").get(0);
  startTime = currentSlide.data("video-start");

 if (slideType === "youtube") {
    switch (control) {
      case "play":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "mute"
        });
        postMessageToPlayer(player, {
          "event": "command",
          "func": "playVideo"
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "pauseVideo"
        });
        break;
    }
  } else if (slideType === "video") {
    video = currentSlide.children("video").get(0);
    if (video != null) {
      if (control === "play"){
        video.play();
      } else {
        video.pause();
      }
    }
  }
}

// Resize player
function resizePlayer(iframes, ratioa) {
  console.log("iframe :"+iframes.length);
  if (!iframes[0]) return;
  var win = $(".homemain-slider"),
      width = win.width(),
      playerWidth,
      height = win.height(),
      playerHeight,
      ratio = ratioa || 16/9;

  iframes.each(function(){
    var current = $(this);
    if (width / ratio < height) {
      playerWidth = Math.ceil(height * ratio);
      current.width(playerWidth).height(height).css({
        left: (width - playerWidth) / 2,
         top: 0
        });
    } else {
      playerHeight = Math.ceil(width / ratio);
      current.width(width).height(playerHeight).css({
        left: 0,
        top: (height - playerHeight) / 2
      });
    }
//     alert(width);
  });
}

// DOM Ready

var breakpointMobile = 768,
    isChanging = false,
    isFiltered = false;

$(function() {
  // Initialize
  slideWrapper.on("init", function(slick){
    slick = $(slick.currentTarget);
    setTimeout(function(){
      playPauseVideo(slick,"play");
    }, 1000);
    resizePlayer(iframes, 16/9);
  });
  slideWrapper.on("beforeChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"pause");
  });
  slideWrapper.on("afterChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"play");
  });

  slideWrapper.on('init breakpoint', function(event, slick){  /** 2. and 5. **/
  if ( ! isChanging ) {                                         /** 4. **/
    $('#breakpointValue').text( String(slick.activeBreakpoint) );
    isChanging = true;
    if ( slick.activeBreakpoint && slick.activeBreakpoint <= breakpointMobile) {
      if ( ! isFiltered ) {
        slick.slickFilter(':not(.hide-on-mobile)');             /** 3. **/
        isFiltered = true;
      }
    } else {
      if ( isFiltered ) {
        slick.slickUnfilter();
        isFiltered = false;
      }
    }
    isChanging = false;
  }
});

  // slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
  //   lazyCounter++;
  //   if (lazyCounter === lazyImages.length){
  //     lazyImages.addClass('show');
  //     // slideWrapper.slick("slickPlay");
  //   }
  // });

  //start the slider
  slideWrapper.slick({
    // fade:true,
    autoplay: true,
    autoplaySpeed:4000,
    lazyLoad:"progressive",
    speed:600,
    arrows:false,
    dots:true,
    cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)",
     responsive: [ 
    { breakpoint: 768 },
  ]
  });
});

// Resize event
$(window).on("resize.slickVideoPlayer", function(){  
  resizePlayer(iframes, 16/9);
});
  
  $( ".tarteaucitron-magic-block" ).append("<h2>Test here</h2>");
  

});

  // tarteaucitron.init({
  //         "privacyUrl": "", /* Privacy policy url */
  //         "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
  //         "cookieName": "tartaucitron", /* Cookie name */
  //         "orientation": "bottom", /* Banner position (top - bottom) */
  //         "showAlertSmall": true, /* Show the small banner on bottom right */
  //         "cookieslist": false, /* Show the cookie list */
  //         "adblocker": false, /* Show a Warning if an adblocker is detected */
  //         "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
  //         "highPrivacy": true, /* Disable auto consent */
  //         "handleBrowserDNTRequest": false, /* If Do Not Track == 1, accept all */
  //         "removeCredit": false, /* Remove credit link */
  //         "moreInfoLink": false, /* Show more info link */
  //   });